var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingOld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 141 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/building01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/building01",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house",
    transform: "translate(20.000000, 54.000000)",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-3.55271368e-15 L0,32.1726394 L0,46.4046514 C0,51.6820931 4.27751463,56 9.56812483,56 C9.65254946,56 9.70883254,56 9.79325717,56 C9.87768181,56 9.93396489,56 10.0183895,56 L29.8863193,56 C34.839231,56 38.8634717,51.9643093 38.8634717,46.9973053 L38.8634717,23.6966065 C38.8634717,22.9346229 39.4825857,22.3137475 40.2424074,22.3137475 L60.7575926,22.3137475 C61.5174143,22.3137475 62.1365283,22.9346229 62.1365283,23.6966065 L62.1365283,46.9973053 C64.5917334,44.5899221 79.2708333,30.358724 106.173828,4.30371094",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,73 L33.0796186,40.8359398 M46.2357781,28.0439088 L70.9641031,4 L139,70.6308594",
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingOld);
export default __webpack_public_path__ + "static/media/building-old.7cc6a9f4854e7221164e27497cb49fdc.svg";
export { ForwardRef as ReactComponent };